import graphql__3a9ebb38ad3efca96319 from "./__generated__/ParticipativeModuleResultsFormFieldMultiBar_result.graphql.js";import { graphql, useFragment } from "react-relay";

import Chart from "./Chart";
import ParticipativeModuleResultsFormFieldContainer from "./ParticipativeModuleResultsFormFieldContainer";
import { multiBarChartConfig } from "../../lib/charts/multiBarChart";
import { useChartOptions } from "../../lib/charts/useChartColors";

const ParticipativeModuleResultsFormFieldMultiBar = props => {
  const result = useFragment(
    ParticipativeModuleResultsFormFieldMultiBar_result,
    props.result
  );

  const { allowDisplayingPatternFill, chartLabel: label, colors } = result;

  const chartOptions = useChartOptions(colors);

  const chartConfig = {
    ...multiBarChartConfig(result, { label }),
    ...chartOptions
  };

  return (
    <ParticipativeModuleResultsFormFieldContainer {...props} result={result}>
      <Chart
        allowDisplayingPatternFill={allowDisplayingPatternFill}
        chartOptions={chartConfig}
      />
    </ParticipativeModuleResultsFormFieldContainer>
  );
};

const ParticipativeModuleResultsFormFieldMultiBar_result = graphql__3a9ebb38ad3efca96319;

export default ParticipativeModuleResultsFormFieldMultiBar;
